import { NotificationHandlerMappings } from "./notificationHandlerMappings";
import { PipelineBehaviorMappings } from "./pipelineBehaviorMappings";
import { RequestHandlerMappings } from "./requestHandlerMappings";
export var typeMappings = {
    pipelineBehaviors: new PipelineBehaviorMappings(),
    notifications: new NotificationHandlerMappings(),
    requestHandlers: new RequestHandlerMappings(),
};
//# sourceMappingURL=index.js.map